import { Link as LinkDom, useLocation, useParams } from "react-router-dom";
import { NavRow } from "@/components/ui/nav-row";
import { cn } from "@/lib/utils";
import styles from "../styles/profile-sidebar.module.css";
import { getUserType } from "../helpers/helpers";

type ProfileSidebarProps = {
  className?: string | undefined;
};

export const ProfileSidebar = ({ className }: ProfileSidebarProps) => {
  const location = useLocation();
  const { id } = useParams();
  const loginType = getUserType();
  const profilePath = `/individual/${id}/account/profile`;
  const paymentPath = `/individual/${id}/account/payment`;
  const isProfileActive = location.pathname.includes(profilePath);
  const isPaymentActive = location.pathname.includes(paymentPath);

  return (
    <div className={cn("w-35 shrink-0 rounded-xl bg-elevated", className)}>
      <div className={cn(styles.tabs_container, "flex flex-col gap-0.5 p-1")}>
        <NavRow
          asChild
          active={isProfileActive}
          className={cn(isProfileActive && "font-medium")}
        >
          <LinkDom to={profilePath}>Profile</LinkDom>
        </NavRow>
        {loginType === "lawyer" && (
          <NavRow
            asChild
            active={isPaymentActive}
            className={cn(isPaymentActive && "font-medium")}
          >
            <LinkDom to={paymentPath}>Payment</LinkDom>
          </NavRow>
        )}
      </div>
    </div>
  );
};
